<template>
    <div id="orbit-container">
      <div id="orbit">
        <div id="sun">
          <img src="/static/images/Precisit-h-white-1600px.png" />
        </div>

        <div id="fellowship-container">
          <div id="moon-2"/>

          <div id="fellowship">
            <div id="moon-orbit">
              <div id="moon"/>
            </div>
            <div id="center-text">
              <div class="header">{{ $t('message.solarSystem.keyValue1') }}</div>
              <div class="subtext">{{ $t('message.solarSystem.keyValue1txt') }}</div>
            </div>
          </div>
        </div>


        <div id="pluralism-container">
          <div id="pluralism">
            <img src="/static/images/planets/pluralism.svg">
            <div id="left-text" class="responsive-move-down">
             <div class="header">{{ $t('message.solarSystem.keyValue2') }}</div>
             <div class="subtext">{{ $t('message.solarSystem.keyValue2txt') }}</div>
            </div>
          </div>
        </div>

        <div id="creativity-container">
          <div id="planet-ring" />

          <div id="creativity">
            <div id="right-text" class="responsive-move-up">
              <div class="header">{{ $t('message.solarSystem.keyValue3') }}</div>
             <div class="subtext">{{ $t('message.solarSystem.keyValue3txt') }}</div>
            </div>
          </div>
        </div>

        <div id="tech-for-humanity-container">
          <div id="tech-for-humanity">
            <img src="/static/images/planets/planet-humanmachine.svg">
            <div id="left-text">
              <div class="header">{{ $t('message.solarSystem.keyValue4') }}</div>
              <div class="subtext">{{ $t('message.solarSystem.keyValue4txt') }}</div>
            </div>
          </div>
        </div>

        <div id="equality-container">
          <div id="equality">
           <img src="/static/images/planets/planet-equality.svg">
            <div id="right-text">
              <div class="header">{{ $t('message.solarSystem.keyValue5') }}</div>
             <div class="subtext">{{ $t('message.solarSystem.keyValue5txt') }}</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolarSystem',
  data() {
    return {};
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/main.scss';
$width-sun: 23%;
#sun{
  width: $width-sun; // Aspect ratio of image: height = 1.2*width
  bottom: calc(50% - #{$width-sun}*1.2/2); //bottom*2 + height = 100%
  left: calc(50% - #{$width-sun}/2);   //left*2 + width = 100%
  position: absolute;
  img {
    width: 0;
    height: 0;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

$planet-width: 105px;
$planet-width-small: 65px;

#orbit-container {
  width: 30vw;
  height: 30vw;
  @include media-breakpoint-up(lg) {
    width: 50vw;
    height: 50vw;
  }
  //margin: 0 auto;
}

#orbit{
  position: relative;
  border-radius: 50%;
  width: 100%;
  height: 100%;

  border:2px dotted rgb(240, 240, 240);
}

%planet {
  position: absolute;
  width: $planet-width;
  height: $planet-width;

  img {
    width: $planet-width;
    @include media("<=desktop") {
      width:  $planet-width-small;
    }
  }
}
%planet-text {
  width: 10rem;
  position: absolute;

  .subtext {
      font-size: 0.8rem;
      color: rgb(154, 168, 175);
      font-family: 'Lato' !important;
  }

  .header {
    font-size: 1rem;
    color: rgb(243, 243, 243);
    font-weight: 600;
    margin-bottom: 1rem;
    font-family: 'Lato' !important;
  }
}


#center-text {
  @extend %planet-text;
  top: $planet-width + $planet-width/3; //to place the text from a certain distance to its parent planet
}

#right-text {
  @extend %planet-text;
  left: $planet-width + $planet-width/1.4;
  top:  $planet-width/3;
}

#left-text {
  @extend %planet-text;
  right: $planet-width + $planet-width/3;
  bottom: 0;
}

.responsive-move-up {
  @include media-breakpoint-down(md) {
    top: -$planet-width !important;
  }
}

.responsive-move-down {
  @include media-breakpoint-down(md) {
    top: $planet-width/2 !important;
  }
}

%planet-container {
  position: absolute;

  height: $planet-width;
  width: $planet-width;

  display: flex;
  justify-content: center;
  align-items: center;
}

#fellowship-container {
  @extend %planet-container;

    right: calc(50% - #{$planet-width}/2);
    bottom: -$planet-width/2;
}

#fellowship {
  @extend %planet;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  background-color: $dark-blue;

  z-index: 2;
}

#moon{
  width: 15px;
  height: 15px;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);

  background-color: $dark-blue;
  position: absolute;
}

#moon-orbit{
  bottom: -10px;
  position:absolute;

  width: 100px;
  height: 100px;

  border-radius:100%;

  -webkit-animation:spin 5s linear infinite;
  animation: spin 5s linear infinite;
}

#moon-2 {
  position:absolute;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);

  width:20px;
  height:20px;

  z-index:3;

  background-color: $dark-blue;
  animation: moon-2-orbit 7s infinite ease-in-out;
}

@include orbit('moon-2-orbit', -45px, -45px, 45px, 45px);

$pluralism-cos: -0.9961947;
$pluralism-sin: -0.08715574;

#pluralism-container {
  @extend %planet-container;

  left: calc(50% - #{$planet-width}/2 + 50%*#{$pluralism-cos});
  bottom: calc(50% - #{$planet-width}/2 + 50%*#{$pluralism-sin});

  img {
    width: 100%;
  }
}

#pluralism {
  @extend %planet;
}


$creativity-cos: 0.866;
$creativity-sin: 0.5;

#creativity-container {
  @extend %planet-container;

  left: calc(50% - #{$planet-width}/2 + 50%*#{$creativity-cos});
  bottom: calc(50% - #{$planet-width}/2 + 50%*#{$creativity-sin});
}

#creativity{
  @extend %planet;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  background-color: $dark-blue;

  z-index: 2;
}

#planet-ring {
  position: absolute;
  z-index: 3;
  height: .35*$planet-width;
  width: 1.65*$planet-width;
  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  //border-top: none;
  animation: ring-bob 1s infinite ease-in-out alternate;
}

$tech-for-humanity-cos: -0.5;
$tech-for-humanity-sin: 0.8660254;

#tech-for-humanity-container {
  @extend %planet-container;

  left: calc(50% - #{$planet-width}/2 + 50%*#{$tech-for-humanity-cos});
  bottom: calc(50% - #{$planet-width}/2 + 50%*#{$tech-for-humanity-sin});
}

#tech-for-humanity {
  @extend %planet;

  border-radius: 50%;
  img {
    width: 100%;
  }

  animation: pulse 1.5s infinite alternate;
}

$equality-cos: 0.8660254;
$equality-sin: -0.5;

#equality-container {
  @extend %planet-container;

  left: calc(49% - #{$planet-width}/2 + 50%*#{$equality-cos});
  bottom: calc(50% - #{$planet-width}/2 + 50%*#{$equality-sin});
  img {
    width: 130%;
  }
}

#equality {
  @extend %planet;
}

@-webkit-keyframes spin {
  100%{
      -webkit-transform:rotate(360deg);
      transform:rotate(360deg);
  }
}
@keyframes spin{
  100%{
      -webkit-transform:rotate(360deg);
      transform:rotate(360deg);
  }
}

@-webkit-keyframes ring-bob {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(3px);
  }
}

@keyframes ring-bob {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(3px);
  }
}

@keyframes pulse {
  from {
    box-shadow: 0px 0px 0px 0px white;
  }
  to{
    box-shadow: 0px 0px 5px 0px white;
  }
}
</style>
